import { AxiosResponse } from 'axios'
import { http } from '../realisations/Http.realisation'
import {
    PVZGetListResponseT,
    PVZGetParamsT,
    PVZUpdateParamsT,
    InvoicesGetParamsT,
    InvoicesGetListResponseT,
    PVZCreateParamsT,
    PVZGetByIDResponseT,
} from '../types/pvz.types'

export class PVZRepository {
    getPVZByID(distribution_center_id: number): Promise<AxiosResponse<PVZGetByIDResponseT>> {
        return http.get(`/pvz/api/v1/admin/distribution-centers/${distribution_center_id}`)
    }

    getList(params: PVZGetParamsT): Promise<AxiosResponse<PVZGetListResponseT>> {
        return http.get('/pvz/api/v1/admin/distribution-centers', { params })
    }

    updatePVZInfo(params: PVZUpdateParamsT): Promise<AxiosResponse<void>> {
        return http.put(`/pvz/api/v1/distribution-centers/${params.id}`, params)
    }

    createPVZ(payload: PVZCreateParamsT): Promise<AxiosResponse<void>> {
        return http.post('/pvz/api/v1/distribution-centers', payload)
    }

    deletePVZ(id: number): Promise<AxiosResponse<void>> {
        return http.delete(`/pvz/api/v1/distribution-centers/${id}`)
    }

    getInvoicesList(params: InvoicesGetParamsT): Promise<AxiosResponse<InvoicesGetListResponseT>> {
        return http.get('/pvz/api/v1/admin/invoices', { params })
    }

    addUser(pvz_id: number, payload: any): Promise<AxiosResponse<void>> {
        return http.post(`/pvz/api/v1/distribution-center/${pvz_id}/users`, payload)
    }

    uploadPhoto(pvz_id: number, form_data: FormData): Promise<AxiosResponse<void>> {
        return http.postFormData(
            `/pvz/api/v1/distribution-center/${pvz_id}/upload-photo`,
            form_data
        )
    }
}
